<div class="container content-box offset-md-4 col-md-4">
  <div>
    @if (!demandeValide) {
      <div>
        @if (tokenInvalide) {
          <div class="custom-alert custom-alert-sm">{{'REINIT_MOT_DE_PASSE.TOKEN_INVALIDE' | translate}}</div>
        }
        @if (!tokenInvalide) {
          <div class="custom-alert custom-alert-sm">{{'REINIT_MOT_DE_PASSE.ERREUR_VALIDATION' | translate}}</div>
        }
        <button class="btn btn-primary" [routerLink]="''">
          {{ 'CREER_MOT_DE_PASSE.ALLER_ACCUEIL' | translate }}
        </button>
      </div>
    }
    @if (demandeValide) {
      <div>
        <div>
          <h3>{{'REINIT_MOT_DE_PASSE.TITRE' | translate }}</h3>
        </div>
        <form (ngSubmit)="onSubmit()">
          <div class="form-group">
            <input type="email" class="form-control" [value]="username" name="username" autocomplete="username" hidden disabled>
            <label for="password">{{'GLOBAL.MOT_DE_PASSE' | translate }}</label>
            <input type="password" class="form-control" [(ngModel)]="password" name="password" id="password">
            @if (mdpRequis) {
              <div class="custom-alert custom-alert-sm">{{'REINIT_MOT_DE_PASSE.MDP_REQUIS' | translate}}</div>
            }
            @if (mdpLongMini) {
              <div class="custom-alert custom-alert-sm">{{'REINIT_MOT_DE_PASSE.MDP_LONG_MINI' | translate}}</div>
            }
          </div>
          <div class="form-group">
            <label for="password">{{'GLOBAL.CONFIRMER' | translate }}</label>
            <input type="password" class="form-control" [(ngModel)]="confirmPassword" name="confirmPassword" id="confirmPassword">
            @if (mdpDifferents) {
              <div class="custom-alert custom-alert-sm">{{'REINIT_MOT_DE_PASSE.MDP_DIFFERENTS' | translate}}</div>
            }
          </div>
          <button type="submit" class="btn btn-outline-success btn-block">{{'GLOBAL.ENREGISTRER' | translate }}</button>
        </form>
      </div>
    }
  </div>
</div>
